<template>
    <div>
        <b-nav tabs>
            <b-nav-item router-link to="report-product">
                <icon name="chart-area"></icon> ยอดขายตามเซลล์ (รหัสสินค้า)
            </b-nav-item>&nbsp;
            <b-nav-item router-link to="report-group-product">
                <icon name="chart-area"></icon> ยอดขายตามเซลล์ (หมวดหมู่สินค้า)
            </b-nav-item>&nbsp;
            <b-nav-item router-link to="report-group-customer">
                <icon name="chart-area"></icon> ยอดขายตามพื้นที่ลูกค้า
            </b-nav-item>&nbsp;
            <b-nav-item router-link to="report-compare-product">
                <icon name="chart-area"></icon> เปรียบเทียบการผลิต
            </b-nav-item>&nbsp;
            <b-nav-item router-link to="report-invoice-sale">
                <icon name="chart-area"></icon> ยอดขายตามบิล (TN)
            </b-nav-item>&nbsp;
        </b-nav>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "dashboard-report-layout"
    }
</script>

<style scoped>

</style>